import { memo, useEffect, useState, useRef } from "react"
import ProductList from "@/components/product/list"
import ProductService from "@/services/product"
import { Box, Flex, Stack, Text } from "@chakra-ui/react"
import { useNavigate, useParams } from "react-router";
import { HStack, Input, Center, AspectRatio, Button, Image, Table, Container, VStack, Float, Drawer, CloseButton, Skeleton, SkeletonText, Separator } from "@chakra-ui/react"
import { LuSearch, LuShoppingCart, LuCopy } from "react-icons/lu"
import { Heading } from "@chakra-ui/react"
import { FaShare } from "react-icons/fa";


import { Field } from "@/components/ui/field"
import Slider from "react-slick";
import { useCart } from "contexts/cart"
import { formatCurrency } from "@/utilities/number"
import { StepperInput } from "@/components/ui/stepper-input"
import { useApp } from "contexts/app"
import { useAuth } from "contexts/auth"

import _ from "lodash"
import { useStore } from "contexts/store";
import BottomSheet from "components/bottom-sheet"
const ShareProduct = ({ open, id, onOpenChange }) => {

    const { user } = useAuth();

    const { copyText } = useApp();
    const { store } = useStore();
    const hasCollaboratorProgram = !!store?.collaborator?.collaborator;

    const copyProductShareLink = () => {
        if (user) {
            copyText(`${store.web.full_url}/product/${id}?ref=${user.id}`)
        } else {
            copyText(`${store.web.full_url}/product/${id}`)
        }
        onOpenChange(false)

    }


    return (
        <div>
            <BottomSheet open={open} onOpenChange={(e) => onOpenChange(e.open)} title="Chia sẻ với gia đình và bạn bè">
                <VStack>
                    <Text>
                        {hasCollaboratorProgram
                            ? "Copy link này, gửi cho bạn bè hoặc đăng lên Facebook, Zalo - mỗi đơn đặt hàng là bạn có hoa hồng liền đó!"
                            : "Copy link này, gửi cho bạn bè hoặc đăng lên Facebook, Zalo để giới thiệu sản phẩm cho mọi người!"}
                    </Text>
                    <Button onClick={copyProductShareLink}><LuCopy></LuCopy> Copy link</Button>
                </VStack>
            </BottomSheet>



        </div>
    )
}

export default memo(ShareProduct)